// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chimney"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M9 21V14L15 11L21 14V21H9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M3 21L4 7L3 3H12L11 7L11.5 12.75L9 14V21H3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M4 7L3 21H9V14L11.5 12.75L11 7M4 7L3 3H12L11 7M4 7H11M15 18V21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9 21V14L15 11L21 14V21H9Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chimney')
export default class ChimneyIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chimney',
    }
  }
}
